var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vh-100"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"card"},[_vm._m(0),_c('div',{staticClass:"card-body"},[_c('pre',[_vm._v(" "+_vm._s(_vm.payment)+" ")])])])])])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-header"},[_c('h5',[_vm._v("Transfer summary")])])
}]

export { render, staticRenderFns }